import classNames from 'classnames/bind';
import { Slider, Rail, Handles } from 'react-compound-slider';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const SliderComponent = ({
  rbi, value, onUpdate, onChange, hasBigScreenDesign,
}) => (
  <div className={cx('range_slider_holder', { rbi, big_screen: hasBigScreenDesign })}>
    <Slider
      className={Styles.range_slider}
      domain={[1, 100]}
      values={[value]}
      step={1}
      mode={1}
      onUpdate={onUpdate}
      onChange={onChange}
    >
      <Rail>
        {({ getRailProps }) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <div className={Styles.range_rail} {...getRailProps()} />
        )}
      </Rail>
      <Handles>
        {({ handles, getHandleProps }) => (
          <div className="slider-handles">
            {handles.map((handle) => (
              <Handle
                key={handle.id}
                handle={handle}
                getHandleProps={getHandleProps}
              />
            ))}
          </div>
        )}
      </Handles>
    </Slider>
  </div>
);

export const Handle = ({
  handle: { id, percent },
  getHandleProps,
}) => (
  <div
    className={Styles.range_handle}
    style={{
      left: `${percent}%`,
    }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...getHandleProps(id)}
  />
);

export default SliderComponent;
